import { render, staticRenderFns } from "./TehBookingDaySchedule.vue?vue&type=template&id=2d2deb66&scoped=true"
import script from "./TehBookingDaySchedule.vue?vue&type=script&lang=js"
export * from "./TehBookingDaySchedule.vue?vue&type=script&lang=js"
import style0 from "./TehBookingDaySchedule.vue?vue&type=style&index=0&id=2d2deb66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2deb66",
  null
  
)

export default component.exports